export enum QuickstartLanguage {
    de, en, es, fr, it, pl, ru, tr
}
